import { useCallback, useMemo } from "react";
import { createColumnHelper } from "@tanstack/react-table"
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

const columnHelper = createColumnHelper();

export const useColumns = ({ name, setData, setFilteredData }) => {
    const { t } = useTranslation();

    const remove = useCallback((id) => {
        setData((prev) => (prev || [])?.filter(
            (item) => item?.id !== id
        ));
        setFilteredData((prev) => (prev || [])?.filter(
            (item) => item?.id !== id
        ))
    }, [setData, setFilteredData]);

    return useMemo(() => {
        let columns = [
            columnHelper.accessor("code", {
                header: t("code")
            }),
            columnHelper.accessor("description", {
                header: t("description")
            }),
        ];

        if (name === "managedLevels") {
            columns.push(columnHelper.accessor("glSegment", {
                header: t("gl-segment")
            }));
        }

        if (name === "managedUsers") {
            columns = [
                columnHelper.accessor("employeeNumber", {
                    header: t("employee-number")
                }),
                columnHelper.accessor("firstName", {
                    header: t("first-name")
                }),
                columnHelper.accessor("lastName", {
                    header: t("last-name")
                })
            ];
        }

        columns.push(columnHelper.display({
            header: t("remove"),
            cell: ({ row: { original: { id } } }) => {
                return (
                    <FontAwesomeIcon
                        icon={faClose}
                        className="text-danger cursor-pointer"
                        onClick={() => remove(id)}
                    />
                )
            }
        }))
        return columns;
    }, [name, remove, t]);
}